import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useStudyStore } from './study';
import { AnalyticsService } from '@/services';
import { Graph, LoadingStateModel, type NetworkGraphValues } from '@/models';

export const useGraphStore = defineStore('graph', () => {
  const studyStore = useStudyStore();
  const graphs = ref<Graph[]>();


  const graphsLoader = ref(new LoadingStateModel({ isLoading: false }));
  const getGraphs = async () => {
    graphsLoader.value.startLoading();
    try {
      if (studyStore.selectedStudyId) {
        graphs.value = await AnalyticsService.getStudyGraphs(studyStore.selectedStudyId);
        graphs.value = graphs.value!.sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime());
        if (graphs.value) {
          for (const graph of graphs.value) {
            try {
              await AnalyticsService.getGraph(graph);
            } catch (error) {
              graph.loading = false;
            }
          }
        }
      }
    } catch (error) {
      graphsLoader.value.setError(error);
    } finally {
      graphsLoader.value.stopLoadingAndFinish();
    }
  };

  const createGraphsLoader = ref(new LoadingStateModel({ isLoading: false }));
  const createGraph = async (postGraph: NetworkGraphValues) => {
    createGraphsLoader.value.startLoading();
    try {
      postGraph.investigation = studyStore.selectedStudyId!;
      await AnalyticsService.postGraph(studyStore.selectedStudyId!, postGraph);
      createGraphsLoader.value.setSuccess('New Graph created!');
      getGraphs();
    } catch (error) {
      createGraphsLoader.value.setError(error);
    } finally {
      createGraphsLoader.value.stopLoadingAndFinish();
    }
  };

  const deleteGraph = async (identifier: string) => {
    graphsLoader.value.startLoading();
    try {
      await AnalyticsService.deleteGraph(identifier);
      graphsLoader.value.setSuccess('Graph deleted!');
      getGraphs();
    } catch (error) {
      graphsLoader.value.setError(error);
    } finally {
      graphsLoader.value.stopLoadingAndFinish();
    }
  };

  return {
    getGraphs,
    createGraph,
    deleteGraph,
    graphs,
    createGraphsLoader
  };
});
